/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { pitchDeckStatusDtoSchema } from "./pitchDeckStatusDtoSchema.ts";
import { processingProgressDtoSchema } from "./processingProgressDtoSchema.ts";
import { ratingDtoSchema } from "./ratingDtoSchema.ts";
import { reviewerDtoSchema } from "./reviewerDtoSchema.ts";
import { z } from "zod/v4";

export const pitchDeckDetailDtoSchema = z.object({
  id: z.optional(z.string()),
  startupName: z.optional(z.string()),
  status: z.optional(z.string()),
  createdAt: z.optional(z.iso.datetime()),
  failureReason: z.string().nullish(),
  get upstreamStatus() {
    return pitchDeckStatusDtoSchema.nullish();
  },
  get processing() {
    return processingProgressDtoSchema.nullish();
  },
  reviewDecision: z.optional(z.string()),
  isWatchlisted: z.optional(z.boolean()),
  get ratings() {
    return z.array(ratingDtoSchema).optional();
  },
  get reviewers() {
    return z.array(reviewerDtoSchema).optional();
  },
});
